import { render, staticRenderFns } from "./shoutu.vue?vue&type=template&id=7f40c7fa&"
import script from "./shoutu.vue?vue&type=script&lang=ts&"
export * from "./shoutu.vue?vue&type=script&lang=ts&"
import style0 from "./shoutu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports